import * as AlertDialog from "@radix-ui/react-alert-dialog"
import styles from './Confirmation.module.scss'
import React from "react";
import {useTranslation} from "react-i18next";
import Button from "./Button";

type Props = {
    trigger: React.ReactElement;
    onConfirm: () => void;
    text: string;
    title?: string
    confirmButtonText?: string | null;
}
const Confirmation = ({ trigger, onConfirm, confirmButtonText, title,  text }: Props) => {

    const { t } = useTranslation();
    
    return (
        <AlertDialog.Root>
            <AlertDialog.Trigger asChild>
                {React.cloneElement(trigger, {style: {cursor: 'pointer'}})}
            </AlertDialog.Trigger>
            <AlertDialog.Portal>
                <AlertDialog.Overlay className={styles.Overlay} />
                <AlertDialog.Content className={styles.Content}>
                    <AlertDialog.Title className={styles.Title}>
                        {title ?? t('areYouSure')}
                    </AlertDialog.Title>
                    <AlertDialog.Description className={styles.Description}>
                        {text}
                    </AlertDialog.Description>
                    <div style={{ display: "flex", gap: 25, justifyContent: "flex-end" }}>
                        <AlertDialog.Cancel asChild>
                            <Button type={"tertiary"} text={t('cancel')} />
                        </AlertDialog.Cancel>
                        <AlertDialog.Action asChild onClick={onConfirm}>
                            <Button type={"secondary"} text={confirmButtonText ?? t('confirm')} />
                        </AlertDialog.Action>
                    </div>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    )

}

export default Confirmation